module.exports = __webpack_public_path__ + "media/npc_dota_hero_pudge.67a41e82.webm";